import { Button, Title } from "@validereinc/common-components";
import { isEqual } from "es-toolkit/compat";
import * as PropTypes from "prop-types";
import React from "react";
import { Checkbox } from "react-bootstrap";
import { getSourceTitle } from "../BalanceHelper";
import InventorySourceTable from "./Inventory/InventorySourceTable";
import SourceTable from "./SourceTable";

const areEqual = (prevProps, nextProps) => {
  return (
    isEqual(prevProps.sources, nextProps.sources) &&
    prevProps.lastUpdatedTime === nextProps.lastUpdatedTime &&
    prevProps.isDisabled === nextProps.isDisabled
  );
};

const SourceInput = React.memo(
  ({
    // @ts-expect-error legacy opshub typing
    title,
    // @ts-expect-error legacy opshub typing
    sourceKey,
    // @ts-expect-error legacy opshub typing
    sources,
    // @ts-expect-error legacy opshub typing
    openSourceSelectionModal,
    // @ts-expect-error legacy opshub typing
    onSyncInletClick,
    // @ts-expect-error legacy opshub typing
    isInventory,
    // @ts-expect-error legacy opshub typing
    showMultiplier,
    // @ts-expect-error legacy opshub typing
    onSourceChecked,
    // @ts-expect-error legacy opshub typing
    onEditClick,
    // @ts-expect-error legacy opshub typing
    isDisabled,
  }) => {
    const shareProps = {
      sourceKey,
      sources,
      showMultiplier,
      onSourceChecked,
      onEditClick,
    };

    return (
      <div className="sourceInput">
        <Title
          type="subheader"
          className="balancesForm__title"
        >
          {title}
        </Title>

        {openSourceSelectionModal && (
          <div className="sourceInput__actionRow">
            <div className="buttonContainer">
              <Button
                onClick={() => openSourceSelectionModal(sourceKey, "add")}
                disabled={isDisabled}
              >
                Add Source
              </Button>

              {sourceKey?.includes("reference") && (
                <Checkbox
                  disabled={isDisabled}
                  onChange={() => onSyncInletClick(sourceKey)}
                >
                  Sync with inlet {getSourceTitle(sourceKey)}
                </Checkbox>
              )}
            </div>
          </div>
        )}

        {isInventory ? (
          <InventorySourceTable
            {...shareProps}
            title="Sample List"
            disabled={isDisabled}
          />
        ) : (
          <SourceTable
            {...shareProps}
            title="Sample List"
            disabled={isDisabled}
          />
        )}
      </div>
    );
  },
  (prevProps, nextProps) => areEqual(prevProps, nextProps)
);

// Used for debugging, React.memo messes with automatic naming
SourceInput.displayName = "SourceInput";

// @ts-expect-error legacy opshub typing
SourceInput.propTypes = {
  title: PropTypes.string.isRequired,
  sourceKey: PropTypes.string,
  sources: PropTypes.array.isRequired,
  openSourceSelectionModal: PropTypes.func,
  syncWithInlet: PropTypes.bool,
  onSyncInletClick: PropTypes.func,
  isInventory: PropTypes.bool.isRequired,
  showMultiplier: PropTypes.bool.isRequired,
  onSourceChecked: PropTypes.func,
  onEditClick: PropTypes.func,
  isDisabled: PropTypes.bool,
};

export default SourceInput;
